export default "__VITE_ASSET__CkAG$UYN__"